/* ============================================================
   SVD PDP Stats 2026
   Skapad av Claude Code – donut count-up + scroll-trigger
   ============================================================ */
(function () {
  'use strict';

  var DURATION = 1200;
  var THRESHOLD = 0.2;

  function easeOutCubic(x) {
    return 1 - Math.pow(1 - x, 3);
  }

  function prefersReducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function setDonut(fill, label, C, pct) {
    var offset = C * (1 - pct / 100);
    fill.setAttribute('stroke-dashoffset', offset);
    label.textContent = Math.round(pct) + '%';
  }

  function animateDonut(donut) {
    if (donut.dataset.svdInit === '1') return;
    donut.dataset.svdInit = '1';

    var fill = donut.querySelector('.svd-stats__donut-fill');
    var label = donut.querySelector('.svd-stats__donut-label');
    if (!fill || !label) return;

    var pct = parseFloat(donut.getAttribute('data-pct')) || 0;
    var animate = donut.getAttribute('data-animate') === 'true';
    var C = parseFloat(fill.getAttribute('data-c')) || 0;

    // Snap direkt om vi inte ska animera, saknar IO, eller reducerad rörelse
    if (!animate || prefersReducedMotion() || !('IntersectionObserver' in window) || !C) {
      setDonut(fill, label, C, pct);
      return;
    }

    // Nollställ innan animation triggas
    setDonut(fill, label, C, 0);

    var started = false;
    var io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting && !started) {
            started = true;
            runCountUp(fill, label, C, pct);
            io.disconnect();
            break;
          }
        }
      },
      { threshold: THRESHOLD }
    );
    io.observe(donut);
  }

  function runCountUp(fill, label, C, target) {
    var t0 = null;
    function step(t) {
      if (t0 === null) t0 = t;
      var k = Math.min(1, (t - t0) / DURATION);
      var val = target * easeOutCubic(k);
      setDonut(fill, label, C, val);
      if (k < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initWithin(root) {
    var scope = root || document;
    var donuts = scope.querySelectorAll
      ? scope.querySelectorAll('.svd-stats__donut')
      : [];
    for (var i = 0; i < donuts.length; i++) animateDonut(donuts[i]);
  }

  function init() {
    initWithin(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify Customizer – ladda om sektion live
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) initWithin(e.target);
  });

  // Re-init om block läggs till/ändras i editorn
  document.addEventListener('shopify:block:select', function (e) {
    if (e.target) initWithin(e.target);
  });
})();
